import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder
} from '@angular/forms';

@Component({
  selector: 'app-license-modal',
  templateUrl: './license-modal.component.html',
  styleUrls: ['./license-modal.component.scss']
})
export class LicenseModalComponent implements OnInit {

  licenseForm: FormGroup;

  licenseField: FormControl = new FormControl('',[]);

  constructor( public dialogRef: MatDialogRef<LicenseModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    fb: FormBuilder) { 
      this.licenseForm = fb.group({
        haslicense: new FormControl(),
        license: this.licenseField
      });

    }

  ngOnInit() {


    if (this.data.message){

      this.licenseField.setValidators(Validators.required);

      this.licenseForm.controls['license'].setErrors({'invalid': true});

      this.licenseForm.controls['license'].markAsTouched();

    }

    if (this.data.config){

      if (this.data.config.validated){
        this.licenseField.setValue(this.data.config.license);
      }

    }

    this.licenseField.valueChanges
    .subscribe((val)=> {
      this.licenseForm.patchValue({haslicense: '2' })
  })
  
  }

 

  closeDialog(): void {
    this.dialogRef.close(this.licenseForm.value);
  }

  onNoClick(): void {
    this.dialogRef.close(this.licenseForm.value);
  }

  onSubmit(val: any){

    if (val.value){

      this.dialogRef.close(val.value);

    }

  }

}



// WEBPACK FOOTER //
// ./src/app/home-page/license-modal/license-modal.component.ts